export enum AccountManagementFeatureFlags {
    ImportOfferMarginInsuranceRecalculate = 'IMPORT_OFFER_MARGIN_INSURANCE_RECALCULATE',
    EnableAMSubmittalsInstructionsPerformance = 'AM-SUBMITTALS-INSTRUCTIONS-PERFORMANCE',
    FacilityFollowupReminders = 'FACILITY-REMINDERS',
    EnableUpdateMarginLinkingExperience = 'ENABLE-UPDATE-MARGIN-LINKING-EXPIRIENCE',
    NonNGRXEnableUpdateMarginLinkingExperience = 'NON-NGRX-ENABLE-UPDATE-MARGIN-LINKING-EXPERIENCE',
    EnableReviewSendButtonTooltip = 'ENABLE-REVIEW-SEND-BUTTON-TOOLTIP',
    EnableNovaPhysicalUnitsCostCenters = 'enable-nova-physical-units-cost-centers',
    EnableNovaNewCostCentersGrid = 'enable-nova-new-cost-centers-grid',
    EnableDefaultOfferEndDateForExtensions = 'enable-default-offer-end-date-for-extensions',
    BulkLiveListNotesLengthValidation = 'bulk-live-list-notes-length-validation',
    UnitVersePhysicalUnitParent = 'unit-verse-physical-unit-parent',
    ExportCandidatesListFix = 'export-candidates-list-fix',
    EnablePhysicalUnitEditLinkingErrorFlow = 'enable-physical-unit-edit-linking-error-flow'
}
